import DataDiri from "./DataDiri";
import TransportasiBerangkat from "./TransportasiBerangkat";
import RiwayatPenyakit from "./RiwayatPenyakit";
import TransportasiPulang from "./TransportasiPulang";
import DressCode from "./DressCode";
import { P } from "../../AbstractElements";

const PreviewJawaban = ({ watch, control, setValue }) => {

  return (
    <div className="preview-jawaban">
      <h3 className="text-dark">Pratinjau Isian Bapak/Ibu</h3>
      <P>Silakan periksa kembali data yang telah diisi. Jika semua sudah benar dan lengkap, mohon tekan tombol <b>Kirim</b> untuk menyimpan jawaban Anda.</P>
      <br /><br />


      <DataDiri control={control} watch={watch} preview={true} />
      <br />
      <TransportasiBerangkat control={control} watch={watch} preview={true} />
      <br />
      <TransportasiPulang control={control} watch={watch} preview={true} />
      <br />
      <DressCode control={control} watch={watch} setValue={setValue} preview={true} />
      <br />
      <RiwayatPenyakit control={control} watch={watch} setValue={setValue} preview={true} />
      
      <style jsx>{`
        .field-label {
          font-weight: 500;
          margin-bottom: 0.5rem;
        }
        .field-value {
          min-height: 38px;
        }
        .preview-section {
          break-inside: avoid;
        }
        .section-header {
          border-radius: 8px;
        }
      `}</style>
    </div>
  );
};

export default PreviewJawaban;